// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1M81n","requiredAsterisk":"Info_requiredAsterisk__a1RDr"};